import { useStore } from '@stores';
import { useEffect } from 'react';

export const useUnAssignedCount = (): { totalCount: number } => {
  const { orderStore } = useStore();

  useEffect(() => {
    orderStore.getUnAssignedCount();
  }, [orderStore]);

  return { totalCount: orderStore.unAssignedTotalCount };
};
